import React, { InputHTMLAttributes } from 'react';
import { Select, Option, TagError, Column } from './styles';

interface IComboBox extends InputHTMLAttributes<HTMLSelectElement> {
  value: any;
  change: (e: any) => void;
  options: { key: any; value: any }[];
  height: string;
  error?: boolean;
  errorMessage?: string;
  placeholder?: string;
  inputStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  placeholderDisabled?: boolean;
}

function ComboBox({
  value,
  change,
  options,
  height,
  error = false,
  errorMessage = '',
  placeholder,
  inputStyle,
  containerStyle,
  placeholderDisabled,
  onBlur,
}: IComboBox) {
  const handlerChange = (value: any) => {
    change(value);
  };

  return (
    <Column error={error} height={height} style={containerStyle}>
      <Select
        onChange={(e) => handlerChange(e.target.value)}
        value={value}
        style={inputStyle}
        onBlur={onBlur}
      >
        <Option value='#' disabled={!!placeholderDisabled}>
          {placeholder ?? 'Selecione'}
        </Option>
        {options.map((state, index) => (
          <Option key={index} value={state.key}>
            {state.value}
          </Option>
        ))}
      </Select>
      {error && <TagError>{errorMessage}</TagError>}
    </Column>
  );
}

export default ComboBox;
